<template>
    <map-layout
        :moduleCode="moduleCode"
        :enableHeader="false"
        :enableFooter="false"
        :enableMainSidebar="false"
        :navTopMenu="false"
        :swipeMenu="false"
        :mainSidebarOnlyMobile="false"
        :fixedTopMenuDashboard="false">

        <template v-slot:main>
            <slot name="main"></slot>
        </template>

        <template v-slot:aside-control>
            <slot name="aside-control"></slot>
        </template>

    </map-layout>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        mixins: [
            GlobalMixin,
        ],
        props: {
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
        },
        data() {
            return {

            }
        },
        components: {

        },
        computed: {
            getStateTool(){
                return  this.moduleCode ? this.$store.getters.getStateTool : null;
            },
        }
    }
</script>
